/* eslint-disable camelcase */
import React from "react";
import cn from "classnames";

import { PageLayout } from "@themuse/design-system";

import SearchFacets from "components/facets/SearchFacets";
import SearchInput from "components/header/SearchInput";
import SearchFilterToggleBar from "components/toggle/SearchFilterToggleBar";

import { useUserState } from "hooks/UserContext";

import styles from "styles/Home.module.scss";
import SearchResults from "./Results";

export const SearchPageLayout = () => {
    const user = useUserState();

    const pageLayoutProps: React.ComponentProps<typeof PageLayout> = {
        activePath: "/search",
        headerClassName: styles.pageHeader,
        pageName: styles.pageWrapper,
        mainClassName: styles.main,
        showSubMenus: true,
        user,
    };

    const [filterOpen, setFilterOpen] = React.useState(false);
    const [clearInputs, setClearInputs] = React.useState(false);

    const handleClose = () => {
        setFilterOpen(false);
    };

    const clearSearch = () => {
        setClearInputs(true);
    };

    const inputsCleared = () => {
        setClearInputs(false);
    };

    return (
        <PageLayout {...pageLayoutProps}>
            <section className={styles.header}>
                <SearchInput
                    clearInputs={clearInputs}
                    onClear={inputsCleared}
                />
            </section>
            <section className={styles.filterToggle}>
                <SearchFilterToggleBar
                    open={filterOpen}
                    onToggle={(open) => setFilterOpen(open)}
                />
            </section>

            <aside className={cn(styles.sidebar, filterOpen ? styles.showSidebar : "")}>
                <SearchFacets onClose={handleClose} onFiltersChange={() => undefined} />
            </aside>
            <article className={styles.content}>
                <SearchResults onClear={clearSearch} />
            </article>
        </PageLayout>
    );
};
